/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiContactDtoContactDto
 */
export interface WebApiContactDtoContactDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiContactDtoContactDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiContactDtoContactDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the WebApiContactDtoContactDto interface.
 */
export function instanceOfWebApiContactDtoContactDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiContactDtoContactDtoFromJSON(json: any): WebApiContactDtoContactDto {
    return WebApiContactDtoContactDtoFromJSONTyped(json, false);
}

export function WebApiContactDtoContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiContactDtoContactDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function WebApiContactDtoContactDtoToJSON(value?: WebApiContactDtoContactDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'description': value.description,
    };
}

